/**
 * @license Angular v19.2.4
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */

import { ɵ$localize as _$localize } from '@angular/localize';
export { ɵ$localize as $localize } from '@angular/localize';

// Attach $localize to the global context, as a side-effect of this module.
globalThis.$localize = _$localize;
